"use client"

import { Box, Grid, Typography, Card, CardContent } from "@mui/material"
import { Business, Topic } from "@mui/icons-material"

const MaterialityComparison = ({ data }) => {
  const companies = data?.comparison?.map(company => ({
    name: company.company_name || 'Unnamed Company',
    topics: company.material_topics || []
  })) || []

  return (
    <Box sx={{ flexGrow: 1, p: 3, backgroundColor: "#fff", minHeight: "100vh" }}>
      <Box sx={{ mb: 4, textAlign: "center" }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            color: "#407775",
            fontWeight: "bold",
            mb: 1,
          }}
        >
          Materiality Topics Comparison
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "#707070",
            maxWidth: "600px",
            mx: "auto",
          }}
        >
          Compare material topics across different companies to identify common themes and unique focus areas
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {companies.map((companyData, index) => (
          <Grid item xs={12} sm={6} lg={4} key={index}>
            <Card
              elevation={0}
              sx={{
                height: "100%",
                border: "1px solid #e0e0e0",
                borderRadius: "12px",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 25px rgba(64, 119, 117, 0.15)",
                  borderColor: "#407775",
                },
              }}
            >
              <CardContent sx={{ p: 3 }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <Business sx={{ color: "#407775", mr: 1 }} />
                  <Typography
                    variant="h6"
                    component="h2"
                    sx={{
                      color: "#407775",
                      fontWeight: "bold",
                    }}
                  >
                    {companyData.name}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <Topic sx={{ color: "#707070", mr: 1, fontSize: "1rem" }} />
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#707070",
                      fontWeight: "medium",
                    }}
                  >
                    {companyData.topics.length} Material Topics
                  </Typography>
                </Box>

                {companyData.topics.length > 0 ? (
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                    {companyData.topics.map((topic, idx) => (
                      <Typography key={idx} variant="body2" sx={{ color: "#407775", ml: 2 }}>
                        • {topic}
                      </Typography>
                    ))}
                  </Box>
                ) : (
                  <Typography
                    variant="body2"
                    sx={{
                      fontStyle: "italic",
                      color: "#707070",
                      ml: 2,
                    }}
                  >
                    No material topics listed.
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {companies.length === 0 && (
        <Box
          sx={{
            p: 4,
            textAlign: "center",
            backgroundColor: "white",
            border: "1px solid #e0e0e0",
            borderRadius: "12px",
            mt: 4,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: "#707070",
              fontStyle: "italic",
            }}
          >
            No company data available for materiality comparison
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default MaterialityComparison
